import DiffPriceWhenEdit from 'components/Price/DiffPriceWhenEdit/container';

export default DiffPriceWhenEdit;
